import {useAppSelector} from '@/redux-store/store';
import {Sport} from '@/types/common';
import {Avatar, Box, Tooltip} from '@mui/material';
import {styled} from '@mui/system';
import {useCallback} from 'react';
import KeycloakInstance from '@/services/keycloak';

export interface Participant {
  name: string | undefined;
  color: string | undefined;
  picture: string | undefined;
  _id: string;
  birthday: string | undefined;
  updatedAt: string | undefined;
  gender: string | undefined;
  description?: string | undefined;
  hometown?: string | undefined;
  sports?: Array<{level: number; sport: Sport}> | null;
  additionalInfo?: string;
}

interface ParticipantAvatarProps {
  participant: Participant;
  index: number;
  onClick: (participant: Participant) => void;
  biggerSize?: boolean;
}

const StyledAvatar = styled(Avatar)(({color}) => ({
  backgroundColor: color,
  cursor: 'pointer',
  objectFit: 'cover'
}));

const getImageSource = (participant: Participant): string => {
  if (participant.picture) {
    return `${participant.picture}?timestamp=${participant.updatedAt}`;
  }
  return '';
};

const ParticipantAvatar: React.FC<ParticipantAvatarProps> = ({
  participant,
  onClick
}) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  let initials = '';

  if (participant.name) {
    const nameParts = participant.name.split(' ');

    if (nameParts.length === 1) {
      initials = nameParts[0].charAt(0).toUpperCase();
    } else {
      initials = nameParts
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
    }
  }

  const handleOpenLoginWindow = useCallback(() => {
    KeycloakInstance.loginExternal().catch((error) => {
      console.error('Login failed: ', error);
    });
    return;
  }, []);

  // console.log('img source: ', getImageSource(participant));
  return (
    <Box m={1} ml={1}>
      <Tooltip title={participant.name ? participant.name : ''}>
        <StyledAvatar
          alt={participant.name}
          color={participant.color}
          src={getImageSource(participant)}
          onClick={() =>
            !isAuthenticated ? handleOpenLoginWindow() : onClick(participant)
          }
        >
          {participant.additionalInfo || (!participant.picture && initials)}
        </StyledAvatar>
      </Tooltip>
    </Box>
  );
};

export default ParticipantAvatar;
